import gql from 'graphql-tag';

const GC_GET_GAME_LIST = gql`
query GetGameList {
  game {
    name
    title
    instruction
    extra_instruction
    id
    headers {
      content
      column
      line
    }
    type: gameType {
      name
      slug
    }
    questions: questionId {
      correction
      column
      line
      id
      text
      answers {
        text
        is_correct
        id
      }
    }
  }
}

`

export {
  GC_GET_GAME_LIST,
}